import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1119fa7a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "crs-section"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sec-title"
}, "比分", -1));
const _hoisted_3 = {
  class: "crs-time"
};
const _hoisted_4 = {
  key: 0,
  class: "tag-init"
};
const _hoisted_5 = {
  key: 1,
  class: "tag-last"
};
const _hoisted_6 = {
  class: "crs-group"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "crs-group-label home"
}, "主胜", -1));
const _hoisted_8 = {
  class: "crs-cols"
};
const _hoisted_9 = {
  class: "crs-label"
};
const _hoisted_10 = {
  key: 0,
  class: "arrow"
};
const _hoisted_11 = {
  class: "crs-group"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "crs-group-label draw"
}, "平局", -1));
const _hoisted_13 = {
  class: "crs-cols"
};
const _hoisted_14 = {
  class: "crs-label"
};
const _hoisted_15 = {
  key: 0,
  class: "arrow"
};
const _hoisted_16 = {
  class: "crs-group"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "crs-group-label away"
}, "负", -1));
const _hoisted_18 = {
  class: "crs-cols"
};
const _hoisted_19 = {
  class: "crs-label"
};
const _hoisted_20 = {
  key: 0,
  class: "arrow"
};
import { computed } from 'vue';
export default {
  __name: 'CrsBlock',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;

    // 官方固定比分顺序（每组末尾为"其它"）
    const HOME_COLS = [['s01s00', '1 : 0'], ['s02s00', '2 : 0'], ['s02s01', '2 : 1'], ['s03s00', '3 : 0'], ['s03s01', '3 : 1'], ['s03s02', '3 : 2'], ['s04s00', '4 : 0'], ['s04s01', '4 : 1'], ['s04s02', '4 : 2'], ['s05s00', '5 : 0'], ['s05s01', '5 : 1'], ['s05s02', '5 : 2'], ['s-1sh', '胜其它']];
    const DRAW_COLS = [['s00s00', '0 : 0'], ['s01s01', '1 : 1'], ['s02s02', '2 : 2'], ['s03s03', '3 : 3'], ['s-1sd', '平其它']];
    const AWAY_COLS = [['s00s01', '0 : 1'], ['s00s02', '0 : 2'], ['s01s02', '1 : 2'], ['s00s03', '0 : 3'], ['s01s03', '1 : 3'], ['s02s03', '2 : 3'], ['s00s04', '0 : 4'], ['s01s04', '1 : 4'], ['s02s04', '2 : 4'], ['s00s05', '0 : 5'], ['s01s05', '1 : 5'], ['s02s05', '2 : 5'], ['s-1sa', '负其它']];
    const homeCols = HOME_COLS.map(([k, l]) => ({
      key: k,
      label: l
    }));
    const drawCols = DRAW_COLS.map(([k, l]) => ({
      key: k,
      label: l
    }));
    const awayCols = AWAY_COLS.map(([k, l]) => ({
      key: k,
      label: l
    }));

    // 每个时间段一个整体块
    const rows = computed(() => (props.list || []).map(x => ({
      date: x.updateDate,
      time: x.updateTime,
      data: x
    })));

    /** 涨跌方向：f 字段 1=涨 -1=跌 0=无 */
    const dir = (row, key) => Number(row.data[key + 'f']) || 0;
    const arrow = (row, key) => dir(row, key) > 0 ? '▲' : '▼';
    const valClass = (row, key) => {
      const d = dir(row, key);
      if (d > 0) return 'up-cell';
      if (d < 0) return 'down-cell';
      return '';
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, ri) => {
        return _openBlock(), _createElementBlock("div", {
          key: ri,
          class: _normalizeClass(["crs-block", {
            'row-first': ri === 0,
            'row-last': ri === rows.value.length - 1
          }])
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(row.date) + " " + _toDisplayString(row.time), 1), ri === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "初始")) : ri === rows.value.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_5, "最新")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeCols), c => {
          return _openBlock(), _createElementBlock("div", {
            key: c.key,
            class: "crs-cell"
          }, [_createElementVNode("div", _hoisted_9, _toDisplayString(c.label), 1), _createElementVNode("div", {
            class: _normalizeClass(["crs-val", valClass(row, c.key)])
          }, [_createTextVNode(_toDisplayString(row.data[c.key]), 1), dir(row, c.key) ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(arrow(row, c.key)), 1)) : _createCommentVNode("", true)], 2)]);
        }), 128))])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(drawCols), c => {
          return _openBlock(), _createElementBlock("div", {
            key: c.key,
            class: "crs-cell"
          }, [_createElementVNode("div", _hoisted_14, _toDisplayString(c.label), 1), _createElementVNode("div", {
            class: _normalizeClass(["crs-val", valClass(row, c.key)])
          }, [_createTextVNode(_toDisplayString(row.data[c.key]), 1), dir(row, c.key) ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(arrow(row, c.key)), 1)) : _createCommentVNode("", true)], 2)]);
        }), 128))])]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(awayCols), c => {
          return _openBlock(), _createElementBlock("div", {
            key: c.key,
            class: "crs-cell"
          }, [_createElementVNode("div", _hoisted_19, _toDisplayString(c.label), 1), _createElementVNode("div", {
            class: _normalizeClass(["crs-val", valClass(row, c.key)])
          }, [_createTextVNode(_toDisplayString(row.data[c.key]), 1), dir(row, c.key) ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(arrow(row, c.key)), 1)) : _createCommentVNode("", true)], 2)]);
        }), 128))])])], 2);
      }), 128))]);
    };
  }
};